import _ from 'lodash'
import Backbone from 'backbone'
import SaveControls from './save-controls'
import reportsMeta from './reports-meta'
import reportHeader from './report-header'
import FormView from 'scoreboard/components/form-view'
import permissions from 'scoreboard/components/permissions'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import { isV5, isV6 } from 'scoreboard/components/version'

var ReportEdit = Backbone.View.extend({

	tagName: 'form',

	className: 'reports-edit table-hack display-layout form',

	events: {
		'click .cancel': 'cancel',
		'submit': 'submit'
	},

	initialize: function(options) {
		this.model.editing = true
		this.header = reportHeader.generate('edit', this.model)

		//create the right form
		let type = this.model.get('subtype')
		var EditView = reportsMeta[type].form
		this.edit = new EditView({ model: this.model, formView: this.formView })

		this._subviews = [this.header, this.edit]

		//handle changes to the period
		this.listenTo(this.header, 'change:period', _.debounce(() => {
			this.model.set('relativePeriodId', globals.periodId)
		}, 500))

		//#9287 hide save controls if no permission to modify reports
		if (this._persistable()) {
			this.controls = new SaveControls({
				model: this.model,
				editForm: true,
				error: function (model, response, options) {
					this.formView.error(response)
				}.bind(this)
			})

			//update the header model on successful sync
			this.listenTo(this.model, 'sync', function() {
				this.header.model.set('label', this.model.get('label'))
			}.bind(this))

			var ReportForm = FormView.extend({
				test: this.controls.test.bind(this.controls)
			})
			this.formView = new ReportForm({
				el: this.el,
				submit: () => {
					return this.controls.submit().then(() => {
						this.formView.start({
							instadone: true,
							primaryButtonEl: this.$('.save')
						})
					})
				},
				toggleCancel: true,
				allowCleanSubmission: this.controls.allowCleanSubmission.bind(this.controls)
			})

			// pass along input change to edit form
			this.listenTo(this.formView, 'change', this.edit.trigger.bind(this.edit, 'change'))

			// listen to any model changes and update the buttons accordingly
			this.listenTo(this.model, 'change', function(e) {
				this.formView.dirty = !!this.model.get('dirty')
				this.formView.valid = !this.controls.test()
				this.formView._updateButtons(this.formView.dirty)
				this.controls.updateButtons()
			}.bind(this))

			this._subviews.push(this.controls)
		} else {
			//the form may re-render as the model changes, with each re-render
			//ensure the no save banner is kept
			let render = this.edit.render
			this.edit.render = () => {
				let v = render.call(this.edit)
				this.$('.scroll-container')
					.prepend(`<div class="banner">${i18n.get('report.warn.noPermissionSaveChangedReports')}</div>`)
				return v
			}
		}
	},


	render: function() {
		this.$el.empty()
		_.each(this._subviews, function(v) {
			this.$el.append(v.$el)
			v.render().delegateEvents()
		}.bind(this))

		//if user has no modify report permissions, this isn't a form
		if (this._persistable()) {
			this.formView.start({
				primaryButtonEl: this.$('.save')
			})
			//if we're showing the save controls on the overview, the form is dirty
			//and should be guarded against
			if (this.controls.allowCleanSubmission()) {
				this.formView.change()
			}
		}

		return this
	},

	_persistable: function() {
		return permissions.reports(globals.orgId)
	},

	cancel: function(e) {
		this.controls && this.controls.cancel(e)
	},

	submit: function(e) {
		// #39377: If we can't save, then there won't be a form view, so we have to
		// prevent submit on enter (keypress) manually.
		if (!this._persistable()) {
			e.preventDefault()
		}
	},

	/**
	 * Handles pre-removal actions.
	 */
	prepareRemove: function() {
		_.invoke(this.edit, 'prepareRemove')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._subviews.concat([this.formView]), 'remove')
	}
})

export default ReportEdit

ReportEdit.__filename__ = 'reports/reports-edit.js'
